import { INSTITUTION_TREE } from '@/data/shared-templates'
import type { InstitutionNode } from '@/data/shared-templates'

/** 用户业务角色 */
export type UserBizRole = 'all' | 'corporate' | 'retail'

/**
 * 根据用户名判断所属业务域。
 * - 用户名包含 "零售" → 零售业务
 * - 用户名包含 "公司" / "对公" / 不含 "零售" 但有 "部经理" → 对公业务
 * - 用户名包含支行名称（叶子节点）→ 全部（但带支行过滤）
 * - 其他 → 全部
 */
export function getUserBizRole(username: string): UserBizRole {
  if (username.includes('零售')) return 'retail'
  if (username.includes('公司') || username.includes('对公')) return 'corporate'
  // "部经理" 默认对公（非零售的部门经理）
  if (username.includes('部经理')) return 'corporate'
  // 支行行长等能看到全部
  return 'all'
}

/** 业务角色对应的模板 category 过滤 */
export const ROLE_CATEGORY_MAP: Record<UserBizRole, string | null> = {
  all: null,        // 不限制
  corporate: '对公业务',
  retail: '零售业务',
}

/** 从机构树中收集所有叶子节点（支行）名称 */
export function getSubBranchNames(nodes: InstitutionNode[]): string[] {
  const result: string[] = []
  const walk = (list: InstitutionNode[]) => {
    for (const n of list) {
      if (!n.children || n.children.length === 0) result.push(n.name)
      else walk(n.children)
    }
  }
  walk(nodes)
  return result
}

/** 根据用户名提取所属支行名称 */
export function getUserBranch(username: string): string | null {
  const branches = getSubBranchNames(INSTITUTION_TREE)
  for (const branch of branches) {
    if (username.includes(branch)) return branch
  }
  return null
}
